<script setup lang="ts">
import type { HTMLAttributeClass } from '@shared/fondof-ui/types'
import clsx from 'clsx'

const props = defineProps<HTMLAttributeClass>()
</script>

<template>
  <div :class="clsx('relative w-full', props.class)">
    <slot />
  </div>
</template>
